// API配置
const config = {
  // 本地开发环境
  // baseURL: 'http://192.168.1.97:8088',
  baseURL: 'https://qtzp.qhdbigdata.com/qtzp-api',
  timeout: 30000, // 请求超时时间（30秒）
  // 请求头配置
  headers: {
    'Content-Type': 'application/json'
  }
}

export default config

